export default {
    items: [
        {
            Name: 'modules',
            Url: '/system/modules',
            Icon: 'fa fa-university'
        },
        {
            Name: 'menus',
            Url: '/system/menus',
            Icon: 'fa fa-list'
        },
        {
            Name: 'language',
            Url: '/system/translate-language',
            Icon: 'fa fa-language'
        }
    ]
}
